module.exports = __webpack_public_path__ + "templates.customer_cancel_order-e1440c1c.html";